/** Ядро ноутбука (умбрелла §3a): интерфейс не знает, где исполняется код.
 *  v1 — PyodideKernel в Web Worker; позже — RemoteKernel к раннеру. */

export type MimeBundle = Record<string, string | string[]>;

export type Output =
  | { output_type: "stream"; name: "stdout" | "stderr"; text: string[] }
  | { output_type: "execute_result"; execution_count: number | null; data: MimeBundle; metadata: Record<string, unknown> }
  | { output_type: "display_data"; data: MimeBundle; metadata: Record<string, unknown> }
  | { output_type: "error"; ename: string; evalue: string; traceback: string[] };

/** Стадии загрузки — тексты E1, переписанные под браузер (спека SP2 §3). */
export type BootStage = "runtime" | "packages" | "kernel" | "datasets";

export const BOOT_STAGES: { stage: BootStage; text: string }[] = [
  { stage: "runtime", text: "Среда получена" },
  { stage: "packages", text: "Пакеты установлены" },
  { stage: "kernel", text: "Ядро запускается" },
  { stage: "datasets", text: "Датасеты подключены" },
];

export type KernelState = "idle" | "booting" | "ready" | "busy" | "dead";

export type KernelStatus = {
  state: KernelState;
  stage?: BootStage;
  /** Когда поднялся воркер — «сессия N мин». */
  startedAt?: number;
  error?: string;
};

export type Dataset = { name: string; url: string };

export type BootOptions = { packages: string[]; datasets: Dataset[] };

export type ExecResult = {
  ok: boolean;
  outputs: Output[];
  durationMs: number;
  error?: { ename: string; evalue: string };
};

export interface Kernel {
  boot(opts: BootOptions): Promise<void>;
  execute(code: string): Promise<ExecResult>;
  /** Прерывание = перезапуск ядра с потерей состояния (SharedArrayBuffer не в v1). */
  interrupt(): Promise<void>;
  restart(): Promise<void>;
  status(): KernelStatus;
  subscribe(fn: (s: KernelStatus) => void): () => void;
  dispose(): void;
}

export const PYODIDE_VERSION = "314.0.7";
export const PYODIDE_INDEX_URL = `https://cdn.jsdelivr.net/pyodide/v${PYODIDE_VERSION}/full/`;
